import { Typography, Stepper, StepLabel, Step } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { ReactComponent as KybHeader } from 'assets/modalKYX/kybImage.svg';

import { ReactComponent as Group98 } from 'assets/modalKYX/Group98.svg';

const useStyles = makeStyles({
    banner: {
        backgroundColor: '#F7F9FC !important',
        maxWidth: '16em',
        minWidth: '16em',
        padding: '1em',
        paddingTop: '2em'
    },
    bannerTitle: {
        fontWeight: '700!important',
        fontSize: '18px!important'
    },
    bannerSpan: {
        textOverflow: 'clip'
    },
    bannerStepper: {
        marginTop: '1em'
    },
    boxBlue: {
        padding: '1em',
        height: '144px',
        backgroundColor: 'rgba(27, 171, 226, 0.2)',
        display: 'flex',
        alignItems: 'center'
    }
});

export const KYBStepBanner = ({ activeStep }) => {
    const classes = useStyles();

    const steps = [
        {
            id: 1,
            label: 'Contact Information'
        },
        {
            id: 2,
            label: 'Tax Information'
        },
        {
            label: 'Business Description'
        },
        {
            label: 'Transaction Information'
        },
        {
            id: 3,
            label: 'Ownership Status'
        },
        {
            id: 4,
            label: 'Ownership Disclosure Endorsement'
        },
        {
            id: 5,
            label: 'Account Type'
        },
        {
            id: 6,
            label: 'Preview'
        }
    ];

    return (
        <Box
            sx={{
                display: { lg: 'initial', md: 'initial', sm: 'none', xs: 'none' }
            }}>
            <Box className={classes.boxBlue}>
                <KybHeader />
                <label
                    style={{
                        marginLeft: '.5em',
                        fontFamily: 'Montserrat',
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        color: '#182D55'
                    }}>
                    KYC Submitted
                </label>
            </Box>
            <Box className={classes.banner}>
                <Group98 />
                <Box className={classes.bannerText}>
                    <Typography variant="h5" component="h5" className={classes.bannerTitle}>
                        Verify Your Business
                    </Typography>
                </Box>
                <Stepper className={classes.bannerStepper} orientation="vertical" activeStep={activeStep}>
                    {steps.map((item, index) => {
                        return (
                            <Step key={item.label + '_' + item.id}>
                                <StepLabel
                                    sx={{
                                        '.MuiStepLabel-label': {
                                            fontSize: '12px',
                                            fontWeight: '700!important',
                                            color: '#7D95A5!important'
                                        },
                                        '.MuiStepIcon-text': {
                                            fill: 'white'
                                        },
                                        '.Mui-active': {
                                            color: '#1BABE2!important'
                                        }
                                    }}>
                                    {item.label}
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            </Box>
        </Box>
    );
};
